
import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal';
import { Context } from 'Context/Context';
import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';
import { preapprovedProfessionals } from 'Constants';
import RevertApproval from '../CaseDetails/RevertApproval';
import { getCaseType } from 'Utils';


function PreApprovedProf({caseInfo, onSubmit, profList}) {

    const [showModal, setShowModal] = useState(false);
    const [singleUser, setSingleUser] = useState(null);
    const {makeApiCallFunc} = useContext(Context);
    const [updateList, setUpdateList] = useState(false);
    const caseId = caseInfo?._id;
    const caseType =  caseInfo?.caseType;
    const caseState = caseInfo?.caseState;

    const [showRemove, setShowRemove] = useState(false);
    const [profData, setProfData] = useState({
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  
    })
  return (
    <>
        {
            showModal &&
            <>
            <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}
                content = {<>
                    <RevertApproval userId={singleUser?._id} caseId={caseId} setUpdateComp={()=>{setShowModal(false);onSubmit()}} caseType={caseType} caseNumber={caseInfo?.caseNumber}/>
                </>}
                />
            
            </>
        }
        <div className='flex items-center flex-col my-8 w-full'>

        {!profList || profList?.length === 0 ? 
        <div className='text-center flex flex-col w-full h-full justify-center items-center'>No legal professionals were pre-approved. <span className='text-sm'><br/>We suggest you check for the available professionals below to preapprove..</span></div>
        :
        
            <div className='flex w-full flex-col'>
                <div className="grid grid-cols-12 gap-0 p-1  bg-white text-[16px] border border-sky-600 ">
                    <div className="font-bold p-2 pt-4 col-span-2 bg-sky-100 text-sky-600">Profile</div>
                    <div className="font-bold p-2 pt-4 col-span-2 text-md bg-sky-100 text-sky-600">Name</div>
                    <div className="font-bold p-2 pt-4 col-span-4 text-md bg-sky-100 text-sky-600">Preference</div>
                    <div className="font-bold p-2 pt-4 col-span-2 text-md bg-sky-100 text-sky-600">Details</div>
                    <div className="font-bold p-2 pt-4 col-span-2 text-md bg-sky-100 text-sky-600">Your Action</div>

                    {profList?.map((ele, index) => {
                    return <>
                    <div className="p-2 w-16 h-16 pt-4 col-span-2  text-gray-800"><img src = {ele?.userId?.profilePic}/>{console.log(ele.userId)}</div>
                    <div className="p-2 pt-4 col-span-2 text-md  text-gray-800"> {ele?.userId?.firstName} {ele?.userId?.lastName}</div>
                    <div className="p-2 pt-4 col-span-4 text-md  text-gray-800">
                        {ele?.userId?.casePref?.filter((i,k) => i === caseType).length ?
                            <span className='bg-sky-600 text-white rounded p-1'>
                               {getCaseType(ele?.userId?.casePref?.filter((i,k) => i === caseType)?.[0])}
                            </span>
                            :
                        ''}
                        {
                            ele?.userId?.statePref?.filter((i,k) => i === caseState).length ?
                            <span className='bg-sky-600 text-white rounded ml-2 p-1'>
                            {ele?.userId?.statePref?.filter((i,k) => i === caseState)}
                            </span>
                            :
                            ''
                        }
                    </div>
                    <div className="p-2 pt-4 col-span-2 text-[16px] underline text-gray-800 cursor-pointer"                              
                    onClick={() => {
                        setSingleUser(ele?.userId); 
                        setShowModal(true)
                    }}
                    >See details</div>
                    <div className="p-2 text-[16px] pt-4 col-span-2  text-gray-800 cursor-pointer">
                        <RevertApproval userId={ele?.userId?._id} caseId={caseId} setUpdateComp={()=>{onSubmit()}} caseType={caseType} caseNumber={caseInfo?.caseNumber}/>
                    </div>
                    </>
                    })}
                </div>
            </div>
        
        }
         </div>
        </>
  )
}



export default PreApprovedProf